export const environment = {
  production: false,
  apiUrl: 'https://api-qa.regenesis.ag',
  bucketUrl: 'https://qa-regenesis-frontend-assets.s3.us-east-2.amazonaws.com',
  googleMapsKey: 'AIzaSyCziAaniffzINQlfuNhkzCTHm_hWPvVZxw',
  stripeKey:
    'pk_test_51QLdWGIxtP2KWAxGEP59mZLwDiVFaxZ4qugTubPBQYjOqyyGt5nPYiyiWKdcq4yLDIG1jjUKfFx9vH8Fq5eNGON300qLZXUS1s',
  googleAnalyticsId: 'G-E1JW8D2HT5',
  laavaScanUrl: 'https://api.laava.id/scan'
};
